import { getField } from 'vuex-map-fields'
const getters = {
  title: (state) => state.app.title,
  primaryColor: (state) => state.app.cssVars.primary,
  getField,
}
export default getters
